/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdmissionStatusInfo } from './AdmissionStatusInfo';
import {
    AdmissionStatusInfoFromJSON,
    AdmissionStatusInfoFromJSONTyped,
    AdmissionStatusInfoToJSON,
    AdmissionStatusInfoToJSONTyped,
} from './AdmissionStatusInfo';

/**
 * 
 * @export
 * @interface AdmissionDetails
 */
export interface AdmissionDetails {
    /**
     * 
     */
    bed_name?: string;
    /**
     * 
     */
    admission_status?: string;
    /**
     * 
     */
    admission_status_info?: AdmissionStatusInfo | null;
    /**
     * 
     */
    previous_admission_details?: AdmissionDetails | null;
}

/**
 * Check if a given object implements the AdmissionDetails interface.
 */
export function instanceOfAdmissionDetails(value: object): value is AdmissionDetails {
    return true;
}

export function AdmissionDetailsFromJSON(json: any): AdmissionDetails {
    return AdmissionDetailsFromJSONTyped(json, false);
}

export function AdmissionDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdmissionDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'bed_name': json['bed_name'] == null ? undefined : json['bed_name'],
        'admission_status': json['admission_status'] == null ? undefined : json['admission_status'],
        'admission_status_info': json['admission_status_info'] === undefined ? undefined : json['admission_status_info'] === null ? null : AdmissionStatusInfoFromJSON(json['admission_status_info']),
        'previous_admission_details': json['previous_admission_details'] === undefined ? undefined : json['previous_admission_details'] === null ? null : AdmissionDetailsFromJSON(json['previous_admission_details']),
    };
}

export function AdmissionDetailsToJSON(json: any): AdmissionDetails {
    return AdmissionDetailsToJSONTyped(json, false);
}

export function AdmissionDetailsToJSONTyped(value?: AdmissionDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'bed_name': value['bed_name'],
        'admission_status': value['admission_status'],
        'admission_status_info': AdmissionStatusInfoToJSON(value['admission_status_info']),
        'previous_admission_details': AdmissionDetailsToJSON(value['previous_admission_details']),
    };
}

